import styled from "@emotion/styled";
import { Box, Button, InputBase, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Web3 from "web3";
import { leftArrow } from "../../../assets";
import { nftTempImage } from "../../../constants";
import { transferNft } from "../../../contract";
import { useAPIActions, useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.primary[500],
  color: `${colors.whiteAccent[900]} !important`,
  marginTop: "30px",
  fontSize: "14px",
  fontWeight: 400,
  width: "100%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const SendView = ({ setStep }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [toAddress, setToAddress] = useState("");
  const [nft, setNft] = useState({});
  const [amount, setAmount] = useState("");
  const [isBackeSpacePressed, setIsBackeSpacePressed] = useState(false);

  const { account, chainId } = useWeb3React();
  const navigate = useNavigate();
  const { address, tokenId } = useParams();
  const { setLoading, setSnackbar } = useUIActions();
  const { updateProfileNftsAfterTransfer, updateProfileNftsAfter1155Transfer } =
    useAPIActions();

  const { profileNfts } = useTypedSelector((state) => state.apiReducer);

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, []);

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, [profileNfts]);

  const onSendCallBack = (msg, status) => {
    setSnackbar({
      open: true,
      severity: status ? "success" : "error",
      message: `${msg}`,
    });
    setLoading(false);
    if (status) {
      const updNfts = profileNfts.map((nft) => {
        if (nft.tokenId === tokenId && nft.nftAddress === address) {
          return {
            ...nft,
            balance: Number(nft.balance) - Number(amount),
          };
        } else {
          return nft;
        }
      });
      nft?.contractType === "ERC1155"
        ? updateProfileNftsAfter1155Transfer(
            updNfts.filter((nft) => Number(nft.balance) !== 0),
            chainId
          )
        : updateProfileNftsAfterTransfer(
            profileNfts,
            nft?.tokenId,
            nft?.nftAddress,
            chainId
          );
    }
    if (status) navigate(`/collections/${address}`);
  };

  const onSend = () => {
    try {
      if (Web3.utils.isAddress(toAddress)) {
        setLoading(true);
        transferNft(
          account,
          toAddress,
          nft?.nftAddress,
          nft?.tokenId,
          nft?.contractType === "ERC1155" ? amount : 0,
          onSendCallBack
        );
      } else {
        throw new Error("Address is not valid");
      }
    } catch (e) {
      setLoading(false);
      setSnackbar({
        open: true,
        severity: "error",
        message: `${e.message}!`,
      });
    }
  };

  return (
    <>
      <img
        src={leftArrow}
        style={{ marginTop: "10px" }}
        alt="arrow"
        onClick={() => setStep(0)}
      />
      <Stack
        direction="row"
        alignItems={"flex-start"}
        justifyContent="space-between"
        width="100%"
        sx={{ marginTop: "20px" }}
      >
        {/* <Box> */}
        <img
          src={nft?.image}
          alt="nft"
          style={{
            width: "424px",
            height: "418px",
            borderRadius: "7px",
          }}
          onError={(e) => (e.currentTarget.src = nftTempImage)}
        />
        {/* </Box> */}
        <Box
          sx={{
            height: "350px",
            width: "70%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            marginTop: "40px",
            marginLeft: "20px",
          }}
        >
          <Box
            width="100%"
            height="49px"
            bgcolor={colors.whiteAccent[900]}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="overline"
              fontWeight={400}
              align="center"
              textAlign={"center"}
              width={"100%"}
              color={colors.black[500]}
            >
              NFT Destination Address
            </Typography>
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={"#F9F8FD"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px",
              "& input": {
                textAlign: "center",
              },
            }}
          >
            <InputBase
              sx={{
                flex: 1,
                fontSize: "14px",
                border: "1px solid #E8ECF5",
                height: "100%",
              }}
              placeholder="Address"
              value={toAddress}
              onChange={(e) => setToAddress(e.target.value)}
            />
          </Box>

          {nft?.contractType === "ERC1155" && (
            <>
              <Box
                width="100%"
                height="49px"
                bgcolor={colors.whiteAccent[900]}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="overline"
                  fontWeight={400}
                  align="center"
                  textAlign={"center"}
                  width={"100%"}
                  color={colors.black[500]}
                >
                  Amount
                </Typography>
              </Box>

              <Box
                width="100%"
                height="49px"
                bgcolor={"#F9F8FD"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& input": {
                    textAlign: "center",
                  },
                }}
              >
                <InputBase
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    border: "1px solid #E8ECF5",
                    height: "100%",
                  }}
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => {
                    const { value } = e.target;

                    const reg = /^[0-9\b]+$/;
                    const test = reg.test(value);

                    if (
                      (!test && !isBackeSpacePressed) ||
                      Number(value) > Number(nft?.balance)
                    ) {
                      return;
                    }

                    setAmount(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 8) {
                      setIsBackeSpacePressed(true);
                    } else {
                      setIsBackeSpacePressed(false);
                    }
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      </Stack>

      <Box
        display="flex"
        flexDirection="row"
        width="98%"
        marginBottom="5px"
        alignItems={"center"}
        justifyContent={"space-between"}
        pl={1}
      >
        <StyledButton
          onClick={() => onSend()}
          variant="outlined"
          colors={colors}
          disabled={
            nft?.contractType === "ERC1155"
              ? toAddress.length === 0 || !amount.length || Number(amount) === 0
              : toAddress.length === 0
          }
        >
          Send
        </StyledButton>
      </Box>
    </>
  );
};

export default SendView;
